import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Switch, Redirect } from "react-router-dom";
import { connect } from "react-redux";
// Import Routes
import { authProtectedRoutes, publicRoutes } from "./routes/index";
import AppRoute from "./routes/route";
// layouts
import VerticalLayout from "./components/VerticalLayout/";
import NonAuthLayout from "./components/NonAuthLayout";
// Import scss
import "./assets/scss/theme.scss";
import axios from "axios";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useMsal, MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./msalConfig";

import Header from "./components/VerticalLayout/Header";
import { fetchAdminClientCreds, fetchBasicAdminDetails } from "helpers/common";
import "./i18n/i18n.js";
import { LogoContext } from "./context/LogoContext";
const pca = new PublicClientApplication(msalConfig);

const App = props => {
  const [subdomain, setsubdomain] = useState(null);
  let history = useHistory();

  useEffect(() => {
    const host = window.location.host;

    const arr = host.split(".");
    let newSubDomain = "";
    if (arr.length > 0) {
      newSubDomain = arr[0];
    }

    async function fetchData(domain) {
      localStorage.setItem("subdomainId", "");
      localStorage.setItem("subdomain", "");
      let config = {
        method: "get",
        url: `${process.env.REACT_APP_API_URL}/admin/job/checkSubdomain/${domain}`,
        headers: {
          "Content-Type": "application/json",
        },
      };
      await axios(config, {
        auth: {
          username: "user",
          password: "password",
        },
      })
        .then(response => {
          if (response.data.status == "fail") {
            history.push("/access-denied");
            // return <Redirect to={{ pathname: "/access-denied" }} />;
          } else {
            //localStorage.setItem("subdomain",subdomain);
            localStorage.setItem("subdomain", domain);
            localStorage.setItem("subdomainId", response?.data?.id);
            const storedLogo = response?.data?.companyLogo;
            const isbehaviourscr = response?.data?.is_behaviourscore;
            const issocial = response?.data?.is_social_enabled;
            if (storedLogo) setLogo(storedLogo);
            localStorage.setItem("isBehaviourScoreEnabled", isbehaviourscr);
            localStorage.setItem("isSocialEnabled", issocial);
          }
        })
        .catch(error => {
          return <Redirect to={{ pathname: "/access-denied" }} />;
          // window.location.href = "/access-denied"
        });
    }

    if (localStorage.getItem("subdomain") !== newSubDomain) {
      fetchData(newSubDomain);
    }

    fetchAdminClientCreds(newSubDomain);
    fetchBasicAdminDetails();
  }, []);

  const getLayout = () => {
    let layoutCls = VerticalLayout;
    return layoutCls;
  };

  const Layout = getLayout();

  // useEffect(() => {
  //   // Set default theme on initial load
  //   document.body.classList.add("theme1");

  //   // Cleanup function to remove theme classes
  //   return () => {
  //     document.body.classList.remove("theme1", "theme2");
  //   };
  // }, []);
  const [companyLogo, setCompanyLogo] = useState(() => {
    // On first render, grab from localStorage
    return localStorage.getItem("logo") || "";
  });

  const setLogo = logo => {
    localStorage.setItem("logo", logo);
    setCompanyLogo(logo);
  };

  return (
    <MsalProvider instance={pca}>
      <LogoContext.Provider value={{ companyLogo, setLogo }}>
        <Router>
          {/* <Header /> */}
          <Switch>
            {publicRoutes.map((route, idx) => (
              <AppRoute
                path={route.path}
                layout={NonAuthLayout}
                component={route.component}
                key={idx}
                name={subdomain}
                isAuthProtected={false}
              />
            ))}
            {authProtectedRoutes.map((route, idx) => (
              <AppRoute
                path={route.path}
                layout={Layout}
                component={route.component}
                key={idx}
                name={subdomain}
                isAuthProtected={true}
                exact
              />
            ))}
          </Switch>
        </Router>
      </LogoContext.Provider>
    </MsalProvider>
  );
};
const mapStateToProps = data => {
  return {
    layout: data.Layout,
  };
};
// App.propTypes = {
//   layout: PropTypes.object,
// }
export default connect(mapStateToProps, null)(App);
